import { render } from "./EditPickupBox.vue?vue&type=template&id=2afdde9b&scoped=true&ts=true"
import script from "./EditPickupBox.vue?vue&type=script&lang=ts"
export * from "./EditPickupBox.vue?vue&type=script&lang=ts"

import "./EditPickupBox.vue?vue&type=style&index=0&id=2afdde9b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afdde9b"]])

export default __exports__